import { motion } from 'framer-motion'

const SectionHeader = ({ kicker, title, text, centered = false }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.35 }}
      transition={{ duration: 0.55, ease: 'easeOut' }}
      className={centered ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl'}
    >
      <p className="section-kicker">{kicker}</p>
      <h2 className="section-title">{title}</h2>
      {text && <p className="section-text">{text}</p>}
    </motion.div>
  )
}

export default SectionHeader
